import React, { Component } from 'react';
import { GenericEditPanel, GenericSelect, GenericOption } from 'com-gyf-webcore-userinterfacecomponents';
import CodigoGeograficoParticular from "./CodigoGeograficoParticular";

class DomicilioParticular extends Component {
    constructor(props) {
        super(props);

        this.actualizarNovedadEstado = this.actualizarNovedadEstado.bind(this);
        this.guardarNovedad = this.guardarNovedad.bind(this);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} estadoId
     * @param {any} entidadId
     */
    actualizarNovedadEstado(novedad, estadoId, entidadId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} value
     */
    guardarNovedad(value) {
        let codPartGeo;

        if (this.props.data.DomicilioParticularCodigoGeografico == 0) {
            codPartGeo = this.props.data.DomicilioParticularCodigoGeograficoInput;
        } else {
            codPartGeo = this.props.data.DomicilioParticularCodigoGeografico;
        }
        this.props.guardarNovedad(codPartGeo);
    }
    /**
     * 
     */
    render() {
        let props = this.props;
        let esValido = false;
        let domicilio = [];
        let domicilioNovedad;
        let novedadCodGeo;
        let error;
        let seEstaEditando = props.dataCompleto.seEstaEditando;
        let codGeoPartNovedad;
        let descripcion;

        //////////Novedad////////////
        let novedadDomicilioPart = undefined;
        if (props.dataCompleto.novedadesCuentaDatos != undefined) {
            novedadDomicilioPart = props.dataCompleto.novedadesCuentaDatos.find(x => x.NovedadCampoCodigo == this.props.codigoNovedad);
            if (novedadDomicilioPart != undefined) {
                let esNovedadEditadaDescripcion = props.dataCompleto.esNovedadEditada.find(x => x.campoCodigo == this.props.codigoNovedad).editado;
                if (esNovedadEditadaDescripcion) {
                    descripcion = props.data.Descripcion;
                }
                else {
                    descripcion = novedadDomicilioPart.ValorNovedad;
                    novedadCodGeo = descripcion;
                }
            }
        }

        codGeoPartNovedad = ((novedadDomicilioPart) ? novedadDomicilioPart.ValorNovedad : this.props.data.DomicilioParticularCodigoGeografico);
        ////////////////////////////////////////////////////
        let domicilioCompleto = "";
        let domicilioParticularBancoTipo = this.props.data.DomicilioParticularBancoTipo;
        let descripcionConcat = "0" + (this.props.data.DomicilioParticularBancoTipo != null ? domicilioParticularBancoTipo : "") + " - ";

        if (novedadDomicilioPart) {
            //domicilioCompleto = novedadDomicilioPart.ValorNovedad;
            let domicilioCodgeo = ""
            if (this.props.data.DomicilioParticularCodigoGeograficoInput) {
                domicilioCodgeo = this.props.data.DomicilioParticularCodigoGeograficoInput;
            } else {
                domicilioCodgeo = novedadDomicilioPart.ValorNovedad;
            }

            domicilioCompleto = descripcionConcat.concat(this.props.data.DomicilioParticularCalle,
                " , ",
                this.props.data.DomicilioParticularNumero,
                " , ",
                this.props.data.DomicilioParticularDepartamentoPartido,
                " , ",
                this.props.data.DomicilioParticularCodigoPostal,
                ". ",
                " (Cód. geográfico " + domicilioCodgeo + ")",
                ". (Telefono " + this.props.data.Telefono + ")");

        } else {
            domicilioCompleto = descripcionConcat.concat(this.props.data.DomicilioParticularCalle,
                " , ",
                this.props.data.DomicilioParticularNumero,
                " , ",
                this.props.data.DomicilioParticularDepartamentoPartido,
                " , ",
                this.props.data.DomicilioParticularCodigoPostal,
                ". ",
                " (Cód. geográfico " + this.props.dataCompleto.cuentaDatosOriginal.DomicilioParticularCodigoGeografico + ")",
                //" (Cód. geográfico " + codGeoPartNovedad + ")",
                ". (Telefono " + this.props.data.Telefono + ")");
        }

        if (props.dataCompleto.domiciliosService) {
            domicilio = JSON.parse(JSON.stringify(props.dataCompleto.domiciliosService));
        }

        let labelDomicilio = <div>
            <label className="label-secondary" >{domicilioCompleto}</label>
            <CodigoGeograficoParticular data={props.data} domicilio={domicilio[0]} novedadCodigoGeografico={novedadCodGeo} novedad={domicilioCompleto}
                CodGeoPartSeleccionado={props.dataCompleto.CodGeoPartSeleccionado}
                form={props.form} guardarCampo={props.guardarCampo} />
        </div>

        if (props.data.DomicilioParticularCodigoGeografico == 0) {
            error = props.data.DomicilioParticularCodigoGeograficoInput != "" ? false : true;
        } else {
            error = false;
        }

        //if (props.dataCompleto.seEstaEditando && props.dataCompleto.componenteSeleccionado == this.props.codigoNovedad) {
        //    esValido = domicilio != undefined ? domicilio.length > 0 ? true : false : false;
        //}

        return (
            <div>
                <GenericEditPanel
                    componente={labelDomicilio}
                    cuenta={props.data}
                    error={error}
                    novedad={novedadDomicilioPart}
                    permisoUsuario={props.dataCompleto.funcionesDelUsuario}
                    seEstaEditando={seEstaEditando}
                    textPanel={domicilioCompleto}
                    title="Domicilio Particular"
                    value={domicilioCompleto}

                    aceptChanges={(value) => this.guardarNovedad(value)}
                    confirmarNovedad={() => this.actualizarNovedadEstado(novedadDomicilioPart, 2, props.data.CuentaTarjetaId)}
                    changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                    denegarNovedad={() => this.actualizarNovedadEstado(novedadDomicilioPart, 3, props.data.CuentaTarjetaId)}
                    mostrarModificaciones={this.props.mostrarModal}
                    revert={this.props.cancelar} />
            </div>
        );
    }
}

export default DomicilioParticular;